// extracted by mini-css-extract-plugin
export default {"productGrid":"XZ-z","centerLink":"YZ-z","productSection":"ZZ-z","item":"_Z-z","ctaButton":"a0-z"};